import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { isArray } from 'lodash';
import moment from 'moment';
import { forkJoin, of, Subject } from 'rxjs';
import { catchError, finalize, first, takeUntil } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/core/service/auth.service';
import { UtilsService } from 'src/app/core/service/utils.service';
import { FileModel } from 'src/app/pages/project-request/models/file.model';
import { ColumnModalComponent } from 'src/app/pages/settings/modal-settings/column-modal/column-modal.component';
import { EventModalComponent } from 'src/app/pages/settings/modal-settings/event-modal/event-modal.component';
import { UserServiceService } from 'src/app/pages/users/services/user-service.service';
import { ModalFilesComponent } from 'src/app/shared/modal-files/modal-files.component';
import { BoardServiceService } from '../../services/board-service.service';
import { FilesServiceService } from '../../services/files-service.service';
import { ConfigurationType, ProjectSettingService } from '../../services/project-setting.service';
import { ProjectsServiceService } from '../../services/projects-service.service';
import { BoardMainScreenService } from '../board-main-screen/board-main-screen.service';
import { User } from 'src/app/core/models/auth.models';
import { TimesListComponent } from '../times-list/times-list.component';

@Component({
  selector: 'app-task-view-modal',
  templateUrl: './task-view-modal.component.html',
  styleUrls: ['./task-view-modal.component.scss']
})
export class TaskViewModalComponent implements OnInit, OnDestroy {

  @ViewChild('confirmSubtaskSwal') confirmSubtaskSwal: SwalComponent
  @ViewChild('confirmTaskSwal') confirmTaskSwal: SwalComponent
  @ViewChild('modalViewTask') modalCreateMember: TemplateRef<NgbModal>;
  @ViewChild('modal', { static: true }) modal: ModalFilesComponent | null = null;
  @ViewChild('modalEvent') modalEvent: EventModalComponent | null = null;
  @ViewChild('modalPriority') modalPriority: EventModalComponent | null = null;
  @ViewChild('modalColumn') modalColumn: ColumnModalComponent | null = null;
  @ViewChild('timesList') timesList: TimesListComponent | null = null;
  destroy$: Subject<boolean> = new Subject<boolean>();

  loggedInUser: User | null = null;
  currency: string = '';
  loading: boolean = false;
  taskId: number = 0;
  task: any = {}
  projectId: number = 0;

  //Files
  files: FileModel[] = [];
  selectedFile: any = null;

  /*time tracking */
  trackingTotal: string = '';
  trackingTotalUpdate: string = '00:00:00';
  trackingTotalRaw: number;
  trackingTotalRawBeginWith: number;
  trackingTotalInterval: any = null;
  running: boolean = false;
  modalReference: NgbModalRef | null;

  /*SUBTASKS */
  subtasksList: any = [];
  subtasksListShow: any = [];
  page: number = 1;
  pageSize: number = 10;
  totalSubtasksSize = 0;
  searchTerm: string = '';
  pageSizeOptions: number[] = [5, 10, 25, 50];

  /*pagination */
  startIndex: number = 0;
  endIndex: number = 0;
  totalRecords: number = 0;

  /*edit */
  edit: boolean = false;
  updateBoard: boolean = false;

  /*EDIT VARIABLES */
  /*form */
  teamId: number | null = null;
  taskForm: FormGroup;
  submitted: boolean = false;
  projectRequest: boolean = false;
  requirementsList: any = [];
  columnsList: any = [];
  sprintsList: any = [];
  usersList: any = [];
  typesList: any = [];
  prioritiesList: any = [];

  //Modal Files
  showModal = false;
  showModalRequestFiles = false;
  deleteFiles: any = [];

  minDate: Date;
  maxDate: Date;

  lastTrackStart: Date | null = null;

  constructor(
    public router: Router,
    private fb: FormBuilder,
    protected authSrv: AuthenticationService,
    private userService: UserServiceService,
    private modalService: NgbModal,
    public translateService: TranslateService,
    public boardMainScreen: BoardMainScreenService,
    private fileSrv: FilesServiceService,
    public sanitizer: DomSanitizer,
    private boardService: BoardServiceService,
    private settingSrv: ProjectSettingService,
    public utilSrv: UtilsService,
    private projectService: ProjectsServiceService,
    private route: ActivatedRoute
  ) {
    this.projectRequest = localStorage.getItem("projectRequestVersionId") == 'null' ? false : true;
  }

  ngOnInit(): void {
    this.projectId = this.route.snapshot.params.projectId;
    this.loggedInUser = this.authSrv.currentUser;
    this.setFormTask();

    this.boardMainScreen.realoadSubtasks.pipe(
      takeUntil(this.destroy$)
    ).subscribe(value => {
      this.loadSubtasks();
    });

    this.boardMainScreen.openTaskModalView.pipe(
      takeUntil(this.destroy$)
    ).subscribe((value: any) => {
      this.taskId = value.taskId;
      this.projectId = value.projectId;

      if (this.taskId === 0) {
        this.loadColumns(Number(-1));
        this.loadTypes();
        this.loadPriorities();

        this.loadSprints();
        this.loadUsers();
        this.loadRequirements();
        this.edit = true;
      } else {
        this.loadSubtasks();
        this.loadTask();
      }
      this.loadProject();
      this.openModal();
      //this.openModal()
    });
  }

  ngOnDestroy() {
    this.updateBoard = false;

    this.destroy$.next(true);
    this.destroy$.unsubscribe();

    this.trackingTotalRaw = 0;
    this.trackingTotalRawBeginWith = 0;

    if (this.trackingTotalInterval)
      clearInterval(this.trackingTotalInterval);
  }

  /** Project */
  loadProject() {
    this.projectService.getProjectInfo(this.projectId)
      .pipe(first())
      .subscribe(response => {
        let data = response.data[0];
        this.currency = data.currency;
      });
  }



  /** Task */
  loadTask() {
    this.loading = true;
    this.files = [];

    this.boardService.getTask(this.taskId).pipe(first()).subscribe((response) => {
      let data = response.data[0];
      data.ativeDate = response.endDate ? (moment(new Date()).isAfter(new Date(response.endDate), 'day') ? false : true) : false;
      data.sameDate = moment(new Date(response.startDate)).isSame(new Date(response.endDate), 'day') ? true : false;
      let estimatedDuration = data.estimatedDuration
      data.estimatedDuration = estimatedDuration != null && estimatedDuration != '' ? (Math.floor(estimatedDuration / 60) + ':' + (data.estimatedDuration % 60 == 0 ? '00' : data.estimatedDuration % 60) + ' h') : ('00:00  h');
      // this.updatedDates = [];

      // if (data.startDate) this.updatedDates.push(new Date(data.startDate));
      // if (data.endDate) this.updatedDates.push(new Date(data.endDate));


      if (data.trackingRunning == true) {
        const end = new Date();
        const sum = moment(end).diff(data.trackingLastStart, 'seconds');
        this.trackingTotal = this.parseSeconds(Number(data.trackingTotal) + Number(sum));
        this.trackingTotalRaw = (Number(data.trackingTotal) + Number(sum));
        this.trackingTotalRawBeginWith = Number(data.trackingTotal);
        this.lastTrackStart = data.trackingLastStart;
        this.activeTrackingInterval();
      } else {
        let total = this.parseSeconds(data.trackingTotal)
        this.trackingTotal = total;
      }
      this.running = data.trackingRunning;
      this.task = data;

      this.task.uploadedFiles.forEach((f: any) => {
        if (!f.deleted) {
          const file = new FileModel(f);
          if (!file.urlSanitize) file.urlSanitize = this.sanitizer.bypassSecurityTrustResourceUrl(`${file.url}?preview=true`);
          this.files.push(file);
        }
      });

      if (this.task.uploadedFiles && this.task.uploadedFiles[0] && (this.task.uploadedFiles[0].mimetype.includes('jpg') || this.task.uploadedFiles[0].mimetype.includes('image') || this.task.uploadedFiles[0].mimetype.includes('jpeg') || this.task.uploadedFiles[0].mimetype.includes('png') || this.task.uploadedFiles[0].mimetype.includes('pdf'))) {
        this.selectFile(this.task.uploadedFiles[0]);
      }

      //if (data.sprintId != null) this.checkDates(data.sprintId)

      this.loading = false;

    }, error => this.utilSrv.toast(`${this.translateService.instant('BOARD.ERROR.LOADTASKS')}: ${error}`, 'error', false))
  }

  openModal() {
    this.updateBoard = false;
    this.selectedFile = null;
    this.modalReference = this.modalService.open(this.modalCreateMember, { centered: true, size: 'xl', scrollable: false, keyboard: false });
  }

  /*SUBTASKS */
  loadSubtasks() {
    this.boardService.getSubtasks(this.projectId, this.taskId).pipe(first()).subscribe(response => {

      this.subtasksList = [];
      this.subtasksListShow = [];
      if (response.data.length > 0) {
        this.subtasksList = response.data.map(({ ...response }: any, index: any) => ({
          ...response,
          key: Number(index) + 1
        }));

        this.totalSubtasksSize = response.data.length;
        this.pagination(1);
      } else {
        this.page = 1;
        this.startIndex = 0;
        this.endIndex = 0;
        this.totalRecords = 0;
        this.pageSize = 10;
        this.totalSubtasksSize = 0;
        this.searchTerm = '';
      }
    }, error => {
      console.error('Load Subtasks', error);
      this.utilSrv.toast(`${this.translateService.instant('BOARD.ERROR.LOADSUBTASKS')}: ${error}`, 'error', false);
    });
  }

  search() {
    if (this.searchTerm != '') {
      let searched = this.subtasksList.filter((element: any) => element.startDate?.toString().includes(this.searchTerm) || element.endDate?.toString().includes(this.searchTerm) || element.priority?.clientDescription.toString().includes(this.searchTerm) || element.column?.name.toString().includes(this.searchTerm) || element.description?.toString().includes(this.searchTerm) || element.title?.toString().includes(this.searchTerm) || element.type?.type.toString().includes(this.searchTerm) || element.sprint?.name.toString().includes(this.searchTerm))
      this.subtasksListShow = searched
      this.totalSubtasksSize = this.subtasksListShow.length;
    } else {
      this.totalSubtasksSize = this.subtasksList.length;
      this.pagination(1);
    }
  }

  pagination(page?: any) {
    this.subtasksListShow = [];
    this.page = page;
    this.subtasksListShow = this.subtasksList.slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
    this.updateCounts(this.totalSubtasksSize);
  }

  updateCounts(count: number) {
    this.totalRecords = count;
    this.startIndex = this.pageSize * (this.page - 1);
    const ps = this.pageSize * (this.page);
    this.endIndex = ps > this.totalRecords ? this.totalRecords : ps;
  }

  addSubtask() {
    this.boardMainScreen.openTaskForm.next({ taskId: this.taskId, sprintId: 0, statusId: 0, projectId: null, supportId: null });
  }

  openSubtask(row: any) {
    this.totalRecords = 0;
    this.taskId = row.id;
    this.loading = false;
    this.files = [];
    this.task = {};
    this.edit = false;
    this.selectedFile = null;
    this.setFormTask();
    this.submitted = false;
    this.loadSubtasks();
    this.loadTask();
    this.page = 1;
    this.startIndex = 0;
    this.endIndex = 0;
    this.totalRecords = 0;
    this.pageSize = 10;
    this.totalSubtasksSize = 0;
    this.searchTerm = '';
  }

  /*files */
  preview() {
    window.open(`${this.selectedFile.url}?preview=true`, '_blank');
  }

  selectFile($event: any) {
    this.selectedFile = $event;
    if (this.selectedFile && !this.selectedFile.urlSanitize) this.selectedFile.urlSanitize = this.sanitizer.bypassSecurityTrustResourceUrl(`${this.selectedFile.url}?preview=true`);
  }

  /*DELETE FUNCTIONS */
  deleteSubtaskPopUp(pl: any) {
    this.utilSrv.confirm('BOARD.DELETESTASK', 'SETTINGS.CONFIRMDELETE', 'SETTINGS.DENYDELETE')
      .then((result) => {
        if (result.isConfirmed) {
          this.deleteSubtask(pl)
        }
      });
  }

  deleteSubtask(pl: any) {
    this.boardService.deleteTask(pl.id)
      .pipe(first())
      .subscribe(() => {
        this.loadSubtasks();
        this.successDeletingPopUp();
      }, (error: any) => {
        console.error('Delete Subtask', error);
        this.errorDeletingPopUp();
      });
  }

  deleteTask(pl: any) {
    this.boardService.deleteTask(pl.id).pipe(first()).subscribe(() => {
      this.successDeletingPopUp();
      this.updateBoard = true;
      this.cancel();
    }, (error: any) => {
      console.error('Delete Task', error);
      this.errorDeletingPopUp();
    });
  }

  /*time counter */

  beforeToggle() {
    if (this.task.assignedId != this.loggedInUser?.id) {
      this.utilSrv.confirm('BOARD.TIMESLIST.TOGGLEASK').then((resp: any) => {
        if (resp.isConfirmed) {
          this.toggle();
        }
      })
    } else {
      this.toggle();
    }

  }

  toggle() {
    this.boardService.toggleTask(this.taskId).pipe(first()).subscribe((response) => {
      this.trackingTotalRaw = response.data[0].accumulatedSum;
      this.trackingTotalRawBeginWith = response.data[0].accumulatedSum;
      let total = this.parseSeconds(response.data[0].accumulatedSum)
      this.trackingTotal = total;

      if (response.data[0].started) {
        this.running = true;
        this.lastTrackStart = response.data[0].trackingLastStart;
        this.activeTrackingInterval();
      } else {
        this.running = false;
        this.desactiveTrackingInterval()
      }
      this.boardMainScreen.reloadCard.next(this.taskId);
      this.boardMainScreen.trackingRunningTopBar.next(this.running);

    }, (error: any) => {
      if (error == 'TASK_USER_ALREADY_ACTIVE_PERIOD') {
        this.utilSrv.toast(this.translateService.instant('BOARD.ACTIVE'), 'warning', false);
      } else {
        this.utilSrv.toast(`Task: ${error}`, 'error', false);
      }
    });
  }


  timeUpdate() {
    const re = /^(?:\d{1,3}:)?\d{2}:\d{2}$/;
    if (re.test(this.trackingTotalUpdate) == false) {
      this.utilSrv.toast(this.translateService.instant('BOARD.ERROR.TIMEERRORPATTERN'), 'warning', false);
      return;
    }

    let data = {
      trackingTotal: this.trackingTotalUpdate,
    }
    this.boardService.timeUpdate(this.projectId, data, this.taskId).pipe(first()).subscribe((response) => {
      this.utilSrv.toast(this.translateService.instant('SETTINGS.UPDATED'), 'success', false);
      this.trackingTotalRaw = response.data[0].accumulatedSum;
      this.trackingTotalRawBeginWith = response.data[0].accumulatedSum;
      this.trackingTotal = this.trackingTotalUpdate;
      this.boardMainScreen.reloadCard.next(this.taskId);
    }, (error: any) => {
      console.error('Update Task', error);
      this.errorPopUp();
    });
  }



  desactiveTrackingInterval() {
    if (this.trackingTotalInterval)
      clearInterval(this.trackingTotalInterval);
  }

  activeTrackingInterval() {
    this.trackingTotalInterval = setInterval(() => {
      this.trackingTotalRaw = this.trackingTotalRawBeginWith + moment(new Date()).diff(this.lastTrackStart, 'seconds');
      this.trackingTotal = this.parseSeconds(this.trackingTotalRaw);
    }, 1000);
  }

  parseSeconds(secondsBackend: number) {
    let totalSeconds = secondsBackend;
    let hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    let minutes = Math.floor(totalSeconds / 60);
    let seconds = totalSeconds % 60;
    return String(hours).padStart(2, "0") + ":" + String(minutes).padStart(2, "0") + ":" + String(seconds).padStart(2, "0")
  }

  /*clear */
  deleteTaskPopUP() {
    this.utilSrv.confirm('BOARD.DELETESTASK', 'SETTINGS.CONFIRMDELETE', 'SETTINGS.DENYDELETE')
      .then((result) => {
        if (result.isConfirmed) {
          this.deleteTask({ id: this.taskId })
        }
      });
  }

  cancel() {
    this.loading = false;
    this.edit = false;

    this.searchTerm = '';
    this.pageSize = 10;
    this.page = 1;
    this.startIndex = 0;
    this.endIndex = 0;
    this.totalRecords = 0;
    this.totalSubtasksSize = 0;

    this.task = {};
    this.taskId = 0;

    this.files = [];
    this.selectedFile = null;

    this.setFormTask();
    this.submitted = false;

    this.desactiveTrackingInterval();

    this.trackingTotalUpdate = '00:00:00';

    this.modalReference?.close();
    if (this.updateBoard) this.boardMainScreen.realoadTasks.next(true);
  }

  /*POP UPS */
  updatedPopUp() {
    this.utilSrv.notify('SETTINGS.UPDATED', 'success');
  }

  errorPopUp() {
    this.utilSrv.notify('SETTINGS.ERROR', 'error');
  }

  errorDeletingPopUp() {
    this.utilSrv.notify('SETTINGS.ERRORDELETING', 'error');
  }

  successDeletingPopUp() {
    this.utilSrv.notify('SETTINGS.DELETED', 'success');
  }

  /*click button switch */
  clickButton(type: number) {
    if (type == 1) {
      this.edit = false;
      if (this.trackingTotalInterval)
        clearInterval(this.trackingTotalInterval);
      this.loadProject();
      this.loadSubtasks();
      this.loadTask();
      this.trackingTotalUpdate = '00:00:00';
    } else if (type == 2) {
      this.edit = true;
      this.setFormTask();
      this.loadContent();
      this.trackingTotalUpdate = this.trackingTotal;

    }
  }

  /*FORM */
  get formTask() { return this.taskForm.controls; }

  setFormTask() {
    this.taskForm = this.fb.group({
      title: ['', Validators.required],
      description: [''],
      typeId: [null, Validators.required],
      columnId: [null],
      sprintId: [null],
      plannedTask: [true, Validators.required],
      requirementId: [null],
      parentId: [null],
      impediments: [''],
      tags: [[]],
      requestedBy: [null],
      uploadFiles: [[]],
      startDate: [null],
      endDate: [null],
      estimatedDuration: [null],
      files: [[]],
      priorityId: [null, Validators.required],
      notes: [null],
      assignedId: [null],
    })
  }

  /*LOAD DATA */

  /*LOAD GLOBAL DATA */
  loadContent() {
    this.boardService.getTask(this.taskId).pipe(first()).subscribe((response) => {
      let data = response.data[0];
      this.teamId = data.sprint?.teamId;

      this.taskForm.patchValue({
        title: data.title,
        description: data.description,
        plannedTask: data.plannedTask,
        files: data.uploadedFiles,
        impediments: data.impediments,
        parentId: data.parentId,
        tags: data.tags,
        notes: data.notes,
        estimatedDuration: data.estimatedDuration != null && data.estimatedDuration != '' ? (Math.floor(data.estimatedDuration / 60) + ':' + (data.estimatedDuration % 60 == 0 ? '00' : data.estimatedDuration % 60) + ' h') : ('00:00  h'),
        startDate: data.startDate == null ? null : new Date(data.startDate),
        endDate: data.endDate == null ? null : new Date(data.endDate),
      });

      if (this.authSrv.hasPermission('projects:board:tasks:create')) {
        this.taskForm.enable();
      } else {
        this.taskForm.disable();
      }


      if (data.sprint) {
        this.loadDataFilters(data.sprint.startDate, data.sprint.endDate);
      } else {
        this.minDate = new Date();
      }

      this.loadColumns(data.columnId == null ? Number(-1) : data.columnId);
      this.loadTypes(data.typeId);
      this.loadPriorities(data.priorityId);

      if (data.sprintId != null) {
        this.loadSprints(data.sprintId);
        this.loadUsers(null, data.sprintId, data.assignedId);
      }
      else {
        this.loadUsers(null, data.sprintId, data.assignedId);
      }


      if (data.requirementId != null) this.loadRequirements(data.requirementId);

    }, error => {
      console.error('Load Task', error);
      this.utilSrv.toast(`${this.translateService.instant('BOARD.ERROR.LOADTASKS')}: ${error}`, 'error', false);
    });
  }

  /*LOAD DROPS */
  loadRequirements(requirementId?: number) {
    this.projectService.getRequirements(this.projectId).pipe(first()).subscribe((response) => {
      if (response.data && isArray(response.data)) {
        this.requirementsList = response.data.map((m: any) => ({ ...m, label: m.requirement, value: m.id }));
        if (requirementId) this.taskForm.patchValue({ requirementId: requirementId });
      }
    }, error => {
      console.error('Load Requirements', error);
      this.utilSrv.notify(`${'REQUIREMENT.ERRORGET'}: ${error}`, 'error', false);
    });
  }

  loadColumns(idColumn?: number) {
    this.boardService.getColumnsDrop(this.projectId).pipe(first()).subscribe(response => {
      this.columnsList = [];

      if (response.data && isArray(response.data)) {
        this.columnsList = response.data.map((m: any) => ({ label: m.name, value: m.id }));
        if (idColumn) this.taskForm.patchValue({ columnId: idColumn })
      }
    }, error => {
      console.error('Load Board Columns', error);
      this.utilSrv.toast(`${this.translateService.instant('BOARD.ERROR.LOADCOLUMNS')}: ${error}`, 'error', false);
    });
  }

  clearAssignedTo() {
    this.usersList = [];
    this.taskForm.patchValue({ assignedId: null });
    this.minDate = null as any;
    this.maxDate = null as any;
  }

  loadSprints(idSprint?: number) {
    this.boardService.getSprintsByProject(this.projectId).pipe(first()).subscribe(response => {
      this.sprintsList = [];
      if (response.data.length > 0) {
        for (let x in response.data) {
          this.sprintsList.push({ label: response.data[x].name, value: response.data[x].id, startDate: response.data[x].startDate, endDate: response.data[x].endDate })
        }
        if (idSprint) this.taskForm.patchValue({ sprintId: idSprint });
      }
    }, error => {
      console.error('Sprints', error);
      this.utilSrv.toast(`${this.translateService.instant('BOARD.ERROR.LOADSPRINTS')}: ${error}`, 'error', false);
    });
  }

  loadTypes(idType?: number) {
    this.boardService.getConfigurations(this.projectId, ConfigurationType.TASK)
      .pipe(first())
      .subscribe(response => {
        this.typesList = [];
        if (response.data.length > 0) {
          for (let x in response.data) {
            this.typesList.push({ label: response.data[x].clientDescription, value: response.data[x].id })
          }
          if (idType) this.taskForm.patchValue({ typeId: idType });
        }
      }, error => {
        console.error('Load Types', error);
        this.utilSrv.toast(`${this.translateService.instant('SETTINGS.EVENT.ERRORGETTASK')}: ${error}`, 'error', false);
      });
  }

  loadPriorities(idPriority?: number) {
    this.boardService.getConfigurations(this.projectId, ConfigurationType.PRIORITY)
      .pipe(first())
      .subscribe(response => {
        this.prioritiesList = [];
        if (response.data.length > 0) {
          for (let x in response.data) {
            this.prioritiesList.push({ label: response.data[x].clientDescription, value: response.data[x].id })
          }
          if (idPriority) this.taskForm.patchValue({ priorityId: idPriority });
        }
      }, error => {
        console.error('Load Priorities', error);
        this.utilSrv.toast(`${this.translateService.instant('SETTINGS.PRIORITY.ERRORGET')}: ${error}`, 'error', false);
      });
  }

  loadUsers(search?: any, sprintId?: number, memberId?: number) {
    if ((this.formTask.sprintId.value != null && sprintId == null) || (sprintId != null)) {
      this.boardService.getSprintTeamMembers(this.projectId, sprintId ? sprintId : this.formTask.sprintId.value, search == null ? null : search).pipe(first()).subscribe(response => {
        this.usersList = [];
        if (response.data.length > 0) {
          for (let x in response.data) {
            this.usersList.push({ label: response.data[x].user.firstName + ' ' + response.data[x].user.lastName, value: response.data[x].userId });
          }
          if (sprintId && memberId) {
            let valor = response.data.filter((d: any) => d.userId == memberId)
            if (valor.length == 0) {
              this.userService.getMembro(memberId).pipe(first()).subscribe(response => {
                this.usersList.push({ label: response.data[0].firstName + ' ' + response.data[0].lastName, value: response.data[0].id })
                this.taskForm.patchValue({ assignedId: memberId });
              });
            } else {
              this.taskForm.patchValue({ assignedId: memberId });
            }
          }
        }

        if (this.usersList?.length == 0) {
          this.taskForm.controls.assignedId.disable();
        } else {
          this.taskForm.controls.assignedId.enable();
        }
      }, error => {
        console.error('Load Members', error);
        this.utilSrv.toast(`${this.translateService.instant('USERS.ERRORMEMBERS')}: ${error}`, 'error', false);
      });
    } else {
      this.projectService.getProjectMembers(this.projectId, search == null ? null : search).pipe(first()).subscribe(response => {
        this.usersList = [];
        if (response.data.length > 0) {
          for (let x in response.data) {
            this.usersList.push({ label: response.data[x].firstName + ' ' + response.data[x].lastName, value: response.data[x].id });
          }
          if (memberId) {
            let valor = response.data.filter((d: any) => d.id == memberId)
            if (valor.length == 0) {
              this.userService.getMembro(memberId).pipe(first()).subscribe(memberResponse => {
                this.usersList.push({ label: memberResponse.data[0].firstName + ' ' + memberResponse.data[0].lastName, value: memberResponse.data[0].id })
                this.taskForm.patchValue({ assignedId: memberId });
              });
            } else {
              this.taskForm.patchValue({ assignedId: memberId });
            }
          }
        }

        if (this.usersList?.length == 0) {
          this.taskForm.controls.assignedId.disable();
        } else {
          this.taskForm.controls.assignedId.enable();
        }
      }, error => {
        this.utilSrv.toast(`${this.translateService.instant('USERS.ERRORMEMBERS')}: ${error}`, 'error', false);
      });
    }
  }

  loadDataFilters(dateS: any, dateE: any) {
    this.minDate = new Date(dateS);
    this.maxDate = new Date(dateE);
  }

  showModalFiles() {
    this.showModalRequestFiles = true;
    this.modal?.open(this.formTask.files.value);
  }

  replaceFiltersData() {
    this.boardService.getSprint(this.formTask.sprintId.value).pipe(first()).subscribe(response => {
      if (response.data.length > 0) {
        this.minDate = new Date(response.data[0].startDate);
        this.maxDate = new Date(response.data[0].endDate);
        this.teamId = response.data[0].teamId;
        if (this.formTask.startDate.value != null) {
          if (moment(this.minDate).isAfter(this.formTask.startDate.value, 'day')) {
            this.taskForm.patchValue({ startDate: this.minDate })
          }
        }
        if (this.formTask.endDate.value != null) {
          if (moment(this.maxDate).isBefore(this.formTask.endDate.value, 'day')) {
            this.taskForm.patchValue({ endDate: this.maxDate })
          }
        }
      }
    })
  }

  saveNeedFiles($event: any) {
    if ($event) {
      if (this.showModalRequestFiles) {
        this.taskForm.patchValue({ files: $event.form });
        this.taskForm.patchValue({ uploadFiles: $event.upload });

        if ($event.delete.length > 0) $event.delete.forEach((f: any) => this.deleteFiles.push(f));
      }
    }
    this.showModalRequestFiles = false;
  }

  /*Dates Validation */
  onChangeStartDate($event: any) {
    const startDate = moment($event);
    const endDate = moment(this.taskForm.value.endDate);
    if (startDate.isAfter(endDate)) {
      this.taskForm.patchValue({ endDate: new Date($event) });
    }
  }

  validateEndDate($event: any) {
    const startDate = moment(this.taskForm.value.startDate);
    const endDate = moment($event)
    if (endDate.isBefore(startDate)) {
      this.taskForm.patchValue({ startDate: new Date($event) });
    }
  }
  /*MODALS */
  /*open type modal */
  openModalEvent() {
    this.modalEvent?.openModal('addEvent', null, this.projectId, 'TASK');
  }

  /*open type priority */
  openModalPriority() {
    this.modalPriority?.openModal('addPriority', null, this.projectId);
  }

  /*open sprint */
  openModalSprint() {
    //this.sprintForm?.openModal(false);
    this.boardMainScreen.openSprintForm.next(false);
  }

  openModalColumn() {
    this.modalColumn?.openModal('addColumn', null, this.projectId);
  }

  /*save */
  editF() {

    this.submitted = true;
    if (this.taskForm.valid && this.taskForm.valid) {
      this.loading = true;
      let data = {
        startDate: this.formTask.startDate.value,
        endDate: this.formTask.endDate.value,
        estimatedDuration: this.formTask.estimatedDuration.value ? moment(this.formTask.estimatedDuration.value, 'hh:mm').diff(moment("00:00 h", 'hh:mm'), 'minutes') : null,
        priorityId: this.formTask.priorityId.value,
        title: this.formTask.title.value,
        description: this.formTask.description.value,
        typeId: this.formTask.typeId.value,
        columnId: this.formTask.columnId.value == Number(-1) ? null : this.formTask.columnId.value,
        sprintId: this.formTask.sprintId.value,
        plannedTask: this.formTask.plannedTask.value,
        assignedId: this.formTask.assignedId.value,
        projectId: Number(this.projectId),
        requirementId: this.formTask.requirementId.value,
        notes: this.formTask.notes.value,
        impediments: this.formTask.impediments.value,
        requestedBy: this.formTask.requestedBy.value,
        tags: this.formTask.tags.value
      }

      this.boardService.updateTask(this.projectId, data, this.taskId).pipe(first()).subscribe((response) => {

        let promiseUpdate = [];
        let promiseDelete = [];
        if (this.formTask.uploadFiles.value.length > 0) {
          promiseUpdate = this.formTask.uploadFiles.value.map((file: File) => this.fileSrv.uploadTaskFile(file, response.data[0].id));
        }

        if (this.deleteFiles.length > 0) {
          promiseDelete = this.deleteFiles.map((file: FileModel) => this.fileSrv.delete(file.id));
        }
        if (this.formTask.uploadFiles.value.length == 0 && this.deleteFiles.length == 0) {
          this.reloadAfterSave();

        } else if (this.formTask.uploadFiles.value.length > 0 && this.deleteFiles.length > 0) {
          forkJoin([
            forkJoin(promiseUpdate),
            forkJoin(promiseDelete)
          ]).pipe(
            first(),
            finalize(() => null),
            catchError(error => {
              this.utilSrv.toast(`${this.translateService.instant('FILES.ERRORSAVE')}: ${error}`, 'error', false);
              return of(false);
            })
          ).subscribe((results) => {
            if (results) {
              this.reloadAfterSave();
            }
          });

        } else if (this.formTask.uploadFiles.value.length > 0 && this.deleteFiles.length == 0) {
          forkJoin(promiseUpdate)
            .pipe(
              first(),
              finalize(() => null),
              catchError(error => {
                this.utilSrv.toast(`${this.translateService.instant('FILES.ERRORSAVE')}: ${error}`, 'error', false);
                return of(false);
              })
            ).subscribe((results) => {
              if (results) {
                this.reloadAfterSave();
              }
            });

        } else if (this.formTask.uploadFiles.value.length == 0 && this.deleteFiles.length > 0) {
          forkJoin(promiseDelete)
            .pipe(
              first(),
              finalize(() => null),
              catchError(error => {
                this.utilSrv.toast(`${this.translateService.instant('FILES.ERRORSAVE')}: ${error}`, 'error', false);
                return of(false);
              })
            ).subscribe((results) => {
              if (results) {
                this.reloadAfterSave();
              }
            });
        }
      }, (error: any) => {
        console.error('Update Task', error);
        this.errorPopUp();
      });
    }
  }

  reloadAfterSave() {
    this.updateBoard = true;
    this.updatedPopUp();
    this.loading = false;
    this.submitted = false;
    this.deleteFiles = [];
    this.taskForm.patchValue({ uploadFiles: [] })
    this.clickButton(1);
    // this.boardMainScreen.reloadCard.next(this.taskId);
  }

  loadTableTimesList() {
    this.timesList?.startTable();
  }
}
